"use client";

import { c as _c } from "react/compiler-runtime";
import { ArrowUpRight } from "lucide-react";
import { ProviderPromoContent, useProviderPromo } from "@llmgateway/shared/components";
export function ProviderPromoBanner() {
  const $ = _c(6);
  const promo = useProviderPromo();
  if (!promo) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ArrowUpRight aria-hidden="true" className="h-3.5 w-3.5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-0.5 group-hover:-translate-y-0.5 motion-reduce:transition-none motion-reduce:transform-none" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== promo) {
    t1 = <div className="container mx-auto flex flex-wrap items-center justify-center gap-x-2.5 gap-y-2 px-4 py-2.5 text-[13px] font-medium leading-tight"><ProviderPromoContent key={promo.id} promo={promo} trailing={t0} /></div>;
    $[1] = promo;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== promo.announcementUrl || $[4] !== t1) {
    t2 = <a href={promo.announcementUrl} target="_blank" rel="noopener noreferrer" className="group block border-b border-neutral-200 bg-white text-neutral-950 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-current dark:border-white/15 dark:bg-neutral-950 dark:text-white">{t1}</a>;
    $[3] = promo.announcementUrl;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}